export const fileName = (filePath: string) => filePath?.replace(/^.*[/\\]/, '');
